import Request from "@gcloud-npm/utils.fetch";
import { findOutEnvByEnvName, FAMILY_API } from "@gcloud-npm/utils.enums.environment";
import Sonda from '@gcloud-npm/utils.monitoring.sonda';
import getUUID from "@gcloud-npm/utils.monitoring.get-uuid";
import { PROCESS_NAME } from "@gcloud-npm/utils.adabyron.make-up-telco-path-name";

const EVENT_NAME = "MISC.REDEEM_CAMPAIGN";

export function redeemCampaign({ data, context: appContext, envName=`${process.env.NEXT_PUBLIC_ENV_NAME}`, idFront = "VT", build = false }) {
  const { campaignId, transactionId } = data;
  
  const myContext = {
    ...appContext,
    environment: findOutEnvByEnvName(envName),
  };

  const { [FAMILY_API.ABS_LAYER_SETH]: connectionData } = myContext.environment;
  const { endpoint: host } = connectionData;
  
  const URL_API = `${host}/movistar-layer/api/client/promotion/v1/campaign/redeem`;

  const idRequest = getUUID(idFront, '', false);

  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context: myContext,
    uniqueId: `idPeticion=${idRequest}`,
    origin: PROCESS_NAME.CLIENT,
  });

  let headers = {
    "Content-Type": "application/json; charset=utf-8",
    Accept: "application/json",
  }

  if(!build) {
    headers.withCredentials = 'true';
  }

  const request = new Request({
    method: "POST",
    endpoint: URL_API,
    data: { campaignId, transactionId },
    headers,
    sonda,
    responseType: "text",
  });
  return request.makeRequest();
}

export default redeemCampaign;